import React from "react";
import { FiList, FiCheck, FiX } from "react-icons/fi";
import { IoIosArrowRoundBack, IoIosArrowRoundForward } from "react-icons/io";
import DOMPurify from "dompurify";

const MainSolutionArea = ({
    question,
    currentIndex = 0,
    total = 0,
    setActiveIndex
}) => {

    console.log('111111111', {
        question,
        currentIndex,
        total,
        setActiveIndex
    });

    /* ---------------- SAFE DERIVED VALUES ---------------- */

    const isLoading = !question;

    const options = Object.entries(question?.options ?? {});

    const sanitizedQuestion = DOMPurify.sanitize(
        question?.questionText ?? ""
    );

    const sanitizedSolution = DOMPurify.sanitize(
        question?.solution ?? ""
    );

    const isMarkedForReview = question?.markForReview || question?.isMarkedForReview || false;
    const correctOption = question?.correctOption ?? null;
    const userAnswer = question?.userAnswer ?? null;
    const explanationSteps = question?.explanation ?? [];

    console.log("explanation:: ", explanationSteps)


    /* ---------------- LOADING STATE ---------------- */

    if (isLoading) {
        return (
            <div className="flex-1 flex items-center justify-center">
                <p className="text-lg font-semibold">
                    Loading Question...
                </p>
            </div>
        );
    }


    /* ---------------- COMPONENT ---------------- */

    return (
        <div className="flex-1 flex flex-col gap-6 font-inter min-w-0 text-left">

            <div className="bg-white rounded-[10px] p-5 md:p-6 border border-[#E0E0E0] shadow-sm">

                {/* HEADER */}
                <div className="flex justify-between items-center mb-5">

                    <span className="text-[14px] md:text-[15px] font-medium text-[#333]">
                        Question {currentIndex + 1} of {total}
                    </span>

                    {question?.difficulty && (
                        <span className="bg-[#D1FAE5] text-[#065F46] px-4 py-1 rounded-full text-[16px] font-[500]">
                            {question.difficulty}
                        </span>
                    )}

                    {isMarkedForReview && (
                        <span className="bg-orange-100 text-orange-600 px-3 py-1 rounded-full text-[13px] font-semibold">
                            Marked For Review
                        </span>
                    )}

                </div>


                {/* QUESTION */}
                <div
                    className="text-[15px] md:text-[16px] text-[#333] mb-6 md:mb-8 font-[500] leading-relaxed"
                    dangerouslySetInnerHTML={{ __html: sanitizedQuestion }}
                />


                {/* OPTIONS */}
                {!!options.length && (
                    <div className="space-y-3 mb-8 md:mb-10">
                        {options.map(([key, value]) => {

                            const isCorrect = key === correctOption;
                            const isUser = key === userAnswer;

                            let style = "border-[#E0E0E0] bg-white";

                            if (isCorrect)
                                style = "bg-[#DCFCE7] border-green-500";

                            if (isUser && !isCorrect)
                                style = "bg-[#FEE2E2] border-[#F87171]";

                            return (
                                <div
                                    key={key}
                                    className={`flex items-center gap-4 p-3 rounded-[5px] border ${style}`}
                                >
                                    <span
                                        className={`w-7 h-7 rounded-full flex items-center justify-center text-[12px] font-bold shrink-0
                                        ${isCorrect
                                                ? "bg-green-500 text-white"
                                                : isUser
                                                    ? "bg-[#EF4444] text-white"
                                                    : "bg-[#E0E0E0] text-[#333]"
                                            }`}
                                    >
                                        {key}
                                    </span>

                                    <span className="text-[14px] text-[#333] font-medium">
                                        {value}
                                    </span>
                                </div>
                            );
                        })}
                    </div>
                )}


                {/* SOLUTION */}
                {question?.solution && (
                    <>
                        <div className="relative inline-block px-4 pb-2">
                            <button className="text-[#E63946] font-[500] text-[15px] cursor-pointer">
                                Detailed Solution
                            </button>
                            <div className="absolute bottom-0 left-0 w-full h-[2px] bg-[#E63946]" />
                        </div>

                        <div className="w-full h-[1px] bg-[#E0E0E0] -mt-[1px]" />

                        <div className="mt-6">
                            <h3 className="flex items-center gap-2 text-[16px] font-bold text-black mb-6">
                                <FiList className="text-xl" />
                                Detailed Solution
                            </h3>

                            <div
                                dangerouslySetInnerHTML={{
                                    __html: sanitizedSolution
                                }}
                            />
                        </div>
                    </>
                )}


                {/* FEEDBACK */}
                {correctOption && (
                    <div className="space-y-4 mt-8">

                        {/* CORRECT */}
                        <div className="bg-[#21C11E29] p-4 rounded-[10px]">
                            <div className="flex items-center gap-2 mb-2 text-[#065F46]">
                                <div className="w-5 h-5 bg-[#10B981] rounded-full flex items-center justify-center text-white">
                                    <FiCheck size={12} />
                                </div>

                                <span className="font-[500] text-[14px] md:text-[16px]">
                                    Correct Answer
                                </span>
                            </div>

                            <p className="font-[500] text-black ml-7 text-[15px] md:text-[16px]">
                                Option {correctOption}
                            </p>
                        </div>


                        {/* USER ANSWER */}
                        {userAnswer && (
                            <div className="bg-[#E6394624] p-4 rounded-[10px]">
                                <div className="flex items-center gap-2 mb-2 text-[#991B1B]">
                                    <div className="w-5 h-5 bg-[#EF4444] rounded-full flex items-center justify-center text-white">
                                        <FiX size={12} />
                                    </div>

                                    <span className="font-[500] text-[14px] md:text-[16px]">
                                        Your Answer
                                    </span>
                                </div>

                                <p className="font-[500] text-black ml-7 text-[15px] md:text-[16px]">
                                    Option {userAnswer}
                                </p>

                                {userAnswer !== correctOption && (
                                    <p className="text-[13px] md:text-[14px] ml-7 mt-1 font-[500]">
                                        Incorrect Answer
                                    </p>
                                )}
                            </div>
                        )}

                    </div>
                )}


                {/* NAVIGATION */}

                {/* <div>

                    <div className="relative inline-block px-4 pb-2">
                        <button className="text-[#E63946] font-[500] text-[15px] cursor-pointer">Detailed Solution</button>
                        <div className="absolute bottom-0 left-0 w-full h-[2px] bg-[#E63946]"></div>
                    </div>
                    <div className="w-full h-[1px] bg-[#E0E0E0] -mt-[1px]"></div>
                    <div className="mt-6">
                        <h3 className="flex items-center font-[500] text-[16px]  gap-2 font-bold text-[#000000] mb-8 md:mb-10">
                            <FiList className="text-xl" /> Detailed Solution
                        </h3>

                        <div className="flex flex-col">
                            <div className="flex items-center  gap-4 mb-4">
                                <span className="bg-[#4096F6] text-white w-7 h-7 rounded-full flex items-center justify-center text-[13px] font-bold shrink-0 shadow-sm">1</span>
                                <p className="font-[500] text-[#000000] text-[15px]">Convert the speed from km/hr to m/s</p>
                            </div>
                            <div className="border-t-2 border-dashed border-[#8C8C8C] mb-4 ml-10"></div>
                            <div className="bg-[#E9E9E9] p-4 md:p-5 ml-5 md:ml-10 border-l-2 border-[#E63946] mb-8 md:mb-10">
                                <p className="text-[14px] font-[500] text-[#000000] mb-1">Conversion Formula:</p>
                                <p className="text-[#000000B2] font-[500] text-[14px] tracking-wide">1 km/hr = (5/18) m/s</p>
                            </div>

                            <div className="flex items-center gap-4 mb-4">
                                <span className="bg-[#4096F6] text-white w-7 h-7 rounded-full flex items-center justify-center text-[13px] font-bold shrink-0 shadow-sm">2</span>
                                <p className="font-[500] text-[#000000] text-[15px]">Calculation Steps</p>
                            </div>
                            <div className="border-t-2 border-dashed border-[#8C8C8C] mb-4 ml-10"></div>
                            <div className="bg-[#E9E9E9] text-[#000000B2] font-[500] text-[14px] p-4 md:p-5 ml-5 md:ml-10 border-l-2 border-[#E63946] mb-8 md:mb-10">
                                60 km/hr = 60 × (5/18) m/s = (300/18) m/s = (50/3) m/s ≈ 16.67 m/s
                            </div>

                            <div className="flex items-center gap-4 mb-4">
                                <span className="bg-[#4096F6] text-white w-7 h-7 rounded-full flex items-center justify-center text-[13px] font-bold shrink-0 shadow-sm">3</span>
                                <p className="font-[500] text-[#000000] text-[15px]">Distance Formula</p>
                            </div>
                            <div className="border-t-2 border-dashed border-[#8C8C8C] mb-4 ml-10"></div>
                            <div className="bg-[#E9E9E9] p-4 md:p-5 ml-5 md:ml-10 border-l-2 border-[#E63946] mb-8 md:mb-10">
                                <p className="text-[14px] font-bold text-[#333] mb-1">Distance Formula:</p>
                                <p className="text-[14px] text-[#000000B2] font-[500] text-[14px] tracking-wide">Distance (Length of train) = Speed × Time</p>
                            </div>

                            <div className="flex items-center gap-4 mb-4">
                                <span className="bg-[#4096F6] text-white w-7 h-7 rounded-full flex items-center justify-center text-[13px] font-bold shrink-0 shadow-sm">4</span>
                                <p className="font-[500] text-[#000000] text-[15px] ">Substitute the values and calculate</p>
                            </div>
                            <div className="border-t-2 border-dashed border-[#8C8C8C] mb-4 ml-10"></div>
                            <div className="bg-[#E9E9E9] text-[#000000B2] font-[500] text-[14px] p-4 md:p-5 ml-5 md:ml-10 border-l-2 border-[#E63946] mb-8 md:mb-10">
                                Length = (50/3) m/s × 9 s = (50 × 9)/3 = 450/3 = 150 meters
                            </div>
                        </div>

                        <div className="space-y-4">
                            <div className="bg-[#21C11E29] p-4 rounded-[10px]">
                                <div className="flex items-center gap-2 mb-2 text-[#065F46]">
                                    <div className="w-5 h-5 bg-[#10B981] rounded-full flex items-center justify-center text-white"><FiCheck size={12} /></div>
                                    <span className="font-[500] text-[14px] md:text-[16px]">Correct Answer</span>
                                </div>
                                <p className="font-[500] text-[#000000] ml-7 text-[15px] md:text-[16px]">150 meters</p>
                                <p className="text-[13px] md:text-[14px] text-[#000000] ml-7 mt-1 font-[500]">Option <span className="font-[600] text-[#000000]">B</span> is the correct answer</p>
                            </div>

                            <div className="bg-[#E6394624] p-4 rounded-[10px]">
                                <div className="flex items-center gap-2 mb-2 text-[#991B1B]">
                                    <div className="w-5 h-5 bg-[#EF4444] rounded-full flex items-center justify-center text-white"><FiX size={12} /></div>
                                    <span className="font-[500] text-[14px] md:text-[16px]">Your Answer</span>
                                </div>
                                <p className="font-[500] text-[#000000] ml-7 text-[15px] md:text-[16px]">Option B</p>
                                <p className="text-[13px] md:text-[14px] text-[#000000] ml-7 mt-1 font-[500]">Option <span className="font-[600] text-[#000000]">A</span> was selected (Incorrect)</p>
                            </div>
                        </div>


                    </div>
                </div> */}


                <div className="flex flex-col">
                    {explanationSteps.map((step, index) => (
                        <React.Fragment key={step._id || index}>

                            {/* STEP HEADING */}
                            <div className="flex items-center gap-4 mb-4">
                                <span className="bg-[#4096F6] text-white w-7 h-7 rounded-full flex items-center justify-center text-[13px] font-bold shrink-0 shadow-sm">
                                    {index + 1}
                                </span>

                                <p className="font-[500] text-[#000000] text-[15px]">
                                    {step.heading}
                                </p>
                            </div>

                            {/* DASH LINE */}
                            <div className="border-t-2 border-dashed border-[#8C8C8C] mb-4 ml-10"></div>

                            {/* STEP TEXT BOX */}
                            <div className="bg-[#E9E9E9] text-[#000000B2] font-[500] text-[14px] p-4 md:p-5 ml-5 md:ml-10 border-l-2 border-[#E63946] mb-8 md:mb-10">
                                {step.text}
                            </div>

                        </React.Fragment>
                    ))}
                </div>


                <div className="flex flex-col sm:flex-row justify-between items-center gap-5 pt-8 md:pt-10 border-t border-[#8C8C8C] mt-10 md:mt-12">



                    <div className="flex gap-3 flex-wrap w-full sm:w-auto">

                        <button
                            disabled={currentIndex === 0}
                            onClick={() => setActiveIndex(prev => prev - 1)}
                            className="flex-1 sm:flex-none flex items-center justify-center gap-2 border border-[#646B6F] px-4 md:px-6 py-2.5 rounded-[4px] text-[14px] text-[#333] hover:bg-gray-50 transition-all disabled:opacity-40"
                        >
                            <IoIosArrowRoundBack size={24} />
                            Prev
                        </button>

                        <button
                            disabled={currentIndex === total - 1}
                            onClick={() => setActiveIndex(prev => prev + 1)}
                            className="flex-1 sm:flex-none bg-[#E63946] text-white px-6 md:px-8 py-2.5 rounded-[4px] text-[14px] flex items-center justify-center gap-2 hover:bg-[#d4313d] transition-all shadow-md disabled:opacity-40"
                        >
                            Next
                            <IoIosArrowRoundForward size={24} />
                        </button>

                    </div>

                    <span className="text-[14px] whitespace-nowrap order-first sm:order-last">
                        {currentIndex + 1}/{total} Questions Viewed
                    </span>

                </div>

            </div>
        </div>
    );
};

export default MainSolutionArea;
